import React, {useState,useEffect} from 'react'
import { Container } from 'react-bootstrap';
import { myId } from '../../lib/MyLibrary';

const ShowDataOldDB = ({data,myFontSize}) => {
  const [dataClient, setDataClient] = useState([]);
  useEffect(() => {
    //console.log('data.data.result:..',data.data.result);
    /* const tempArray = Object.entries(data.data.result);
    const dataArray = tempArray.filter((item)=>item[0]!=='_id'&&item[0]!=='__v');
    //console.log('dataArrayDB:..',dataArray);
    if (dataArray) setDataClient(dataArray); */
    const tempData = {...data.data.result[0]};
    if(tempData){
      const tempArray = [
        [ 'idAptos:', tempData.idAptos||'null'],
        [ 'email:', tempData.email||'null'],
        [ 'Nombre:', tempData.firstName||'null'],
        [ 'Apellido(s):', tempData.lastName||'null'],
        [ 'Fecha de Nacimiento:', tempData.birthDate||'null'],
        [ 'Género:', tempData.gender||'null'],
        [ 'Código Postal:', tempData.codigoPostal||'00000'],
        [ 'Fecha de Creación:', tempData.altaml||'null'],
        [ 'Cupón:', tempData.cuponml||'null'],
        [ 'Cupón onLine:', String(tempData.cupononline)||'null'],
        [ 'Vigencia:', String(tempData.cuponvigencia)||'null'],
        [ 'Newsletter:', String(tempData.isNewsletterOptIn)||'null']       
      ]
      setDataClient(tempArray);
    }else setDataClient(null);
    
    return 
  }, [])
  return (
    <div>
      <Container fluid style={{width: "90%"}} className='border borde-2 bg-light p-3 rounded'>
      {dataClient && 
        <div>
        {dataClient?.map((item)=> {
      
          return <p key={myId()} style={{ width: "90%" }} className="text-secondary fs-6 my-0 ms-auto me-auto">
          <span style={{ width: "40%", fontSize: myFontSize }} className="border border-2 d-inline-block ps-2 pt-1">{item[0]}</span>
          <span style={{ width: "60%", fontSize: myFontSize }} className="border border-2 text-danger d-inline-block ps-2 pt-1">{item[1]}</span>
        </p>
        
      })}
      </div>
    }
      </Container>
    </div>
  )
}

export default ShowDataOldDB